import type { QueryParamsDto } from "@mimber/schema"

/**
 * Query key utilities for member orders hooks
 * Keys match backend controller method names
 */
export const memberOrdersKeys = {
  getMemberOrders: (memberUuid: string, params?: QueryParamsDto) =>
    params
      ? (["member-orders", memberUuid, "getMemberOrders", params] as const)
      : (["member-orders", memberUuid, "getMemberOrders"] as const),
} as const
